import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {WhatsAppSettings} from './components/WhatsAppSettings';

export function WhatsApp() {
  return (
    <SettingsTemplate
      header={{title: i18n.t('page.integrations.labels.whatsApp')}}
      data-testid="integrations-whatsApp-settings"
    >
      <WhatsAppSettings />
    </SettingsTemplate>
  );
}
